import React, {Component} from 'react';
import {Card, CardBody, CardHeader, Col, ListGroup, ListGroupItem, Row} from "reactstrap";
import api from "api";
import LoadingSpinner from "components/LoadingSpinner";
import PropTypes from "prop-types";
import HelpModeIconTooltip from "components/HelpModeIconTooltip";

class TabSummary extends Component {

  constructor(props) {
    super(props);

    this.state = {
      stats: false
    }
  }

  componentDidMount() {
    api.surveyCollector.sms.get.stats(this.props.collector).then(stats => {
      this.setState({
        stats
      })
    })
  }

  render() {
    const {collector} = this.props;
    const {stats} = this.state;

    if(stats === false){
      return <LoadingSpinner/>
    }

    return (
      <React.Fragment>
        <HelpModeIconTooltip className="mb-2">Statystyki tego kolektora</HelpModeIconTooltip>
        <Row>
          <Col lg={4} className="d-flex align-items-md-stretch">
            <Card className="w-100 border-l orange">
              <CardHeader><h2>Respondenci</h2></CardHeader>
              <hr className="my-0" />
              <CardBody>
                <ListGroup>
                  <ListGroupItem>Liczba: {stats.addressesCount}</ListGroupItem>
                  <ListGroupItem>Wysłanych zaproszeń: {stats.sentCount}</ListGroupItem>
                  <ListGroupItem>W trakcie wysyłki: {stats.inSendCount}</ListGroupItem>
                </ListGroup>
              </CardBody>
            </Card>
          </Col>
          <Col lg={4} className="d-flex align-items-md-stretch">
            <Card className="w-100 border-l violet">
              <CardHeader><h2>Wypełnienia</h2></CardHeader>
              <hr className="my-0" />
              <CardBody>
                <ListGroup>
                  <ListGroupItem>Zakończone: {stats.finishedCount} ({(((stats.finishedCount / stats.addressesCount) || 0) * 100).toFixed(2)} %)</ListGroupItem>
                  <ListGroupItem>Screenout: {stats.screenoutCount} ({(((stats.screenoutCount / stats.addressesCount) || 0) * 100).toFixed(2)} %)</ListGroupItem>
                  <ListGroupItem>Przerwane: {stats.breakCount} ({(((stats.breakCount / stats.addressesCount) || 0) * 100).toFixed(2)} %)</ListGroupItem>
                  <ListGroupItem>Brak kontaktu: {stats.notStartedCount} ({(((stats.notStartedCount / stats.addressesCount) || 0) * 100).toFixed(2)} %)</ListGroupItem>
                </ListGroup>
              </CardBody>
            </Card>
          </Col>
          <Col lg={4} className="d-flex align-items-md-stretch">
            <Card className="w-100 border-l blue">
              <CardHeader><h2>Ustawienia</h2></CardHeader>
              <hr className="my-0" />
              <CardBody>
                <ListGroup>
                  <ListGroupItem>Max reminderów: {collector.reminder.count}</ListGroupItem>
                  <ListGroupItem>Wyślij po upływie: {collector.reminder.sendAfter} godz.</ListGroupItem>
                </ListGroup>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </React.Fragment>
    )
  }
}

TabSummary.propTypes = {
  collector: PropTypes.object.isRequired,
};

export default TabSummary;